export default function KeyValue({ val, getHandlers }) {
    if (typeof val !== 'object' || !Object.keys(val)?.length) return '-';
    return (
        <div>
            {Object.keys(val).map((item) => (
                <p key={Math.random}>{getHandlers('formatter') ? getHandlers('formatter', item) : `${item}: ${val[item]}`}</p>
            ))}
        </div>
    );
}
